import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

export const Actions = styled.div`
  background-color: ${plume.COLORS.PRIMARY_GREY_000};
  bottom: 0;
  display: flex;
  justify-content: end;
  margin: 0;
  padding: 16px 0;
  position: sticky;
  right: 0;
  z-index: 2;

  ${plume.LinkAsButton} {
    margin: 0 10px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    bottom: 16px;
    justify-content: center;
    left: unset;
    padding: 0;
    position: absolute;
    right: 16px;
  }
`
